import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { createReduxEnhancer } from '@sentry/react';
const sentryReduxEnhancer = createReduxEnhancer({
  actionTransformer: action => {
    // avoid sending sensitive data to sentry. Only send action type, without payload!
    // https://docs.sentry.io/platforms/javascript/guides/react/data-management/sensitive-data/
    return {
      type: action.type
    };
  },
  stateTransformer: state => {
    // avoid sending sensitive data to sentry. Keep in mind that certain data cannot be sent to sentry
    // due to user data protection policies.
    // https://docs.sentry.io/platforms/javascript/guides/react/data-management/sensitive-data/
    return {
      searchParams: state.searchParams,
      searchResults: state.searchResults,
      inventoryResults: state.inventoryResults,
      itemDetail: state.itemDetail // ...

    };
  }
});
export function configureStore(initialReducers) {
  const store = createStore(combineReducers(initialReducers), compose(applyMiddleware(thunk), sentryReduxEnhancer));
  store.asyncReducers = {};

  store.injectReducer = asyncReducer => {
    store.asyncReducers = { ...store.asyncReducers,
      ...asyncReducer
    };
    const combinedReducers = combineReducers({ ...initialReducers,
      ...store.asyncReducers
    });
    store.replaceReducer(combinedReducers);
  };

  return store;
}